// extracted by mini-css-extract-plugin
export default {"colorTextLabel":"d4-z","colorTextValue":"e4-z","swatches":"f4-z","collapseLink":"g4-z","isCollapsed":"h4-z","dropdown":"i4-z","disabled":"j4-z"};